import gql from "graphql-tag"

export default gql`
  query allTags($user: String!) {
    User: userByUsername(username: $user) {
      tags {
        id
        name
      }
    }
  }
`
